import './NewExchange.scss';

import { API } from 'aws-amplify';
import getSymbolFromCurrency from 'currency-symbol-map';
import React, { Fragment, useCallback, useEffect, useState } from 'react';
import CurrencyFormat from 'react-currency-format';
import { connect } from 'react-redux';
import Modal from 'react-responsive-modal';

import reasonCodes from '../../../data/reasonCodes';
import { layoutActions } from '../../../redux/actions/layouts';
import { handleUnauthorizedError } from '../../../utils';
import ProductSearchModal from './ProductSearchModal';

const showImage = (media, name) => {
    if (media && media[0]) {
        return (
            <img
                className="img-responsive order-item-detail__image"
                src={media[0].location + '?w=80&h=80'}
                alt={name}
            />
        );
    } else {
        return null;
    }
};

const NewExchange = ({
    displayErrorDialog,
    setChosenItem,
    setModalOpen,
    reasonCode,
    modalOpen,
    quantity,
    item,
}) => {
    const [exchangeItem, setExchangeItem] = useState(null);
    const [exchangeItemDetails, setExchangeItemDetails] = useState(null);
    const [sizes, setSizes] = useState([]);
    // const [reason, setReason] = useState(false);
    // const [qty, setQty] = useState(productQty);
    const [selectedSize, setSelectedSize] = useState(null);
    const [productSearchOpen, setProductSearchOpen] = useState(false);
    const [originalItem, setOriginalItem] = useState(null);

    const selectSize = useCallback(
        sizeExternalID => {
            try {
                const size = sizes.filter(({ externalID }) => externalID === sizeExternalID);

                if (!size.length || selectedSize === size[0]) {
                    return;
                }

                setSelectedSize(size[0]);
            } catch (err) {
                console.error('error selecting size', err);
            }
        },
        [sizes, selectedSize],
    );

    useEffect(() => {
        if (item !== null && exchangeItem === null) {
            setOriginalItem(item);
            setExchangeItem(item);
        }
    }, [item, exchangeItem]);

    useEffect(() => {
        setOriginalItem(item);
        setExchangeItem(item);
    }, [item]);

    // If exchange item ever changes we need to look up the details
    useEffect(() => {
        if (exchangeItem !== null) {
            getItemDetails(exchangeItem);
        }
    }, [exchangeItem]);

    // If the product details change we need to create a new size list
    useEffect(() => {
        if (exchangeItemDetails !== null) {
            const productSizes = createSizes(exchangeItemDetails);

            let uniqueProductSizes = productSizes.sort((a, b) => a.externalID > b.externalID);
            uniqueProductSizes = uniqueProductSizes.filter(
                ({ externalID }, index) =>
                    index ===
                    uniqueProductSizes.findIndex(
                        ({ externalID: searchExternalID }) => externalID === searchExternalID,
                    ),
            );

            setSizes(uniqueProductSizes);
            setSelectedSize(uniqueProductSizes[0]);
        }
    }, [exchangeItemDetails]);

    // If the sizes update we need to auto select the first one.
    useEffect(() => {
        const firstSize = sizes.length > 0 ? sizes[0] : null;
        selectSize(firstSize);
    }, [selectSize, sizes]);

    return (
        <Modal
            open={modalOpen}
            onClose={() => {
                setOriginalItem(null);
                setExchangeItem(null);
                setModalOpen(false);
            }}
            classNames={{
                modal: 'exchange-product-search-modal',
                closeButton: 'exchange-product-search-modal-close',
            }}
            center
        >
            {modalOpen ? (
                <table className="table">
                    <thead>
                        <tr>
                            <th>Product</th>
                            <th>Size</th>
                            <th>Reason</th>
                            <th>Qty</th>
                            <th>Total</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr className="new-exchange-row">
                            <td className="new-exchange-product-name-td">
                                {exchangeItemDetails !== null ? (
                                    <Fragment>
                                        {showImage(
                                            exchangeItemDetails.media,
                                            exchangeItemDetails.name,
                                        )}
                                        <span className="new-exchange-name-span">
                                            {exchangeItemDetails.name}
                                        </span>
                                        <div className="text-center">
                                            <button
                                                className="btn btn-default new-exchange-link-button"
                                                onClick={() => setProductSearchOpen(true)}
                                            >
                                                Change product
                                            </button>
                                        </div>
                                    </Fragment>
                                ) : (
                                    <div className="text-center">
                                        <button
                                            className="btn btn-default new-exchange-link-button"
                                            onClick={() => setProductSearchOpen(true)}
                                        >
                                            Change product
                                        </button>
                                    </div>
                                )}
                            </td>
                            <td>
                                {sizes.length > 0 ? (
                                    <select
                                        className="form-control"
                                        value={
                                            selectedSize !== null
                                                ? sizes.filter(
                                                      ({ externalID }) =>
                                                          externalID === selectedSize.externalID,
                                                  ).externalID
                                                : ''
                                        }
                                        onChange={event => selectSize(event.target.value)}
                                    >
                                        {sizes
                                            ? sizes.map(({ externalID, optionValue }) => (
                                                  <option key={externalID} value={externalID}>
                                                      {optionValue}
                                                  </option>
                                              ))
                                            : ''}
                                    </select>
                                ) : (
                                    <span>No sizes available</span>
                                )}
                            </td>
                            <td>
                                <select
                                    className="form-control"
                                    value={reasonCode}
                                    disabled={true}
                                    // onChange={handleReasonChange}
                                >
                                    <option value="">Reason:</option>
                                    {reasonCodes.map(({ code, description }) => {
                                        if (code === '06') {
                                            return null;
                                        }

                                        return (
                                            <option key={code} value={code}>
                                                {description}
                                            </option>
                                        );
                                    })}
                                </select>
                            </td>
                            <td>
                                <select
                                    className="form-control"
                                    value={quantity}
                                    disabled={true}
                                    // onChange={handleQuantityChange}
                                >
                                    <option value={quantity}>{quantity}</option>
                                    {/* {[...Array(exchangeItem.quantity)].map(
                                        (e, i) => (
                                            <option
                                                key={'return-qty-' + i}
                                                value={i}
                                            >
                                                {i}
                                            </option>
                                        )
                                    )} */}
                                </select>
                            </td>
                            <td>
                                {exchangeItem ? (
                                    <CurrencyFormat
                                        fixedDecimalScale={true}
                                        decimalScale={2}
                                        thousandSeparator={true}
                                        displayType="text"
                                        value={(quantity * exchangeItem.prices.price) / 100}
                                        prefix={getSymbolFromCurrency(exchangeItem.prices.currency)}
                                    />
                                ) : null}
                            </td>
                        </tr>
                        <tr>
                            <td colSpan={5}>
                                <div className="float-right">
                                    <button className="btn btn-success" onClick={handleOnSubmit}>
                                        Confirm
                                    </button>
                                </div>
                            </td>
                        </tr>
                    </tbody>
                    <ProductSearchModal
                        setModalOpen={setProductSearchOpen}
                        setItemSelected={itemSelected}
                        modalOpen={productSearchOpen}
                        facia={item.facia}
                        item={item}
                    />
                </table>
            ) : null}
        </Modal>
    );

    function handleOnSubmit() {
        const error = errorExchange();

        setExchangeItem(null);

        if (error.length) {
            setSelectedSize(null);
            setModalOpen(false);
            displayErrorDialog('New Exchange', error);
            return;
        }

        setChosenItem({
            original: {
                ID: originalItem.ID,
            },
            exchange: {
                currency: selectedSize.prices.currency,
                price: selectedSize.prices.price,
                size: selectedSize.optionValue,
                plu: selectedSize.productID,
                name: exchangeItem.name,
                sku: selectedSize.ID,
            },
        });

        setSelectedSize(null);
        setModalOpen(false);
    }

    function errorExchange() {
        let error = '';

        if (exchangeItem && selectedSize && exchangeItem.ID === selectedSize.ID) {
            error = 'Product chosen is the original item purchased.';
        } else if (!exchangeItem.productID || !exchangeItem.name.length) {
            error = 'Exchange not added due to missing fields.';
        }

        return error;
    }

    function itemSelected(product) {
        setProductSearchOpen(false);
        setExchangeItem(product);
    }

    async function getItemDetails(item) {
        const plu = item.productID.replace(item.facia + '-', '');

        API.get('product', `/admin?facia=${item.facia}&plu=${plu}`, {}).then(
            result => {
                setExchangeItemDetails(result);
            },
            error => {
                handleUnauthorizedError(error);
                console.log(error);
            },
        );
    }

    function createSizes(product) {
        return null === product
            ? []
            : product.productOptions
                  .filter(size => size.inStock)
                  .sort(function (a, b) {
                      return a.optionValue - b.optionValue;
                  });
    }
};

const mapDispatchToProps = dispatch => {
    return {
        displayErrorDialog: (title, message) =>
            dispatch(layoutActions.displayErrorDialog(title, message)),
    };
};

export default connect(null, mapDispatchToProps)(NewExchange);
